
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getOrderServiceInit, createOrderService, getCustomerAddressInfo } from '@/api/orderService';
import { getFaultList, getPriceList } from '@/api/other';
import { UserModule } from '@/store/modules/user';
import { addOrderServerIsHave, addOrderServerIsMust, checkPermissionUseAndCompany } from '@/utils/permission';
import { getAvinfo, makeKey } from '@/utils/qiniu';

import SelectDepartment from '@/components/DeptDialog/index.vue';
import OrderTag from '../order/components/OrderTag.vue';
import OrderArea from '../order/components/OrderArea.vue';
import CustomerDialog from '@/components/CustomerDialog/levelByLevel.vue';
import DialogSetImport from '../staff/components/setImport.vue';
import OrderBrand from '../order/components/OrderBrand.vue';
import OrderDevice from '@/components/DeviceSelectDialog/index.vue';
import OrdertParts from '../order/components/OrderParts.vue';
import { Type } from '@/types/permissionType';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import CustomerAddDialog from '../customer/components/CustomerAddDialog.vue';
import BenzAMRRecorder from 'benz-amr-recorder';
import OrderNotice from '../order/components/OrderNotice.vue';
import SelectFaultDialog from '@/components/SelectFaultDialog/index.vue';

@Component({
  name: 'orderServicerAdd',
  components: {
    SelectDepartment,
    OrderTag,
    CustomerDialog,
    DialogSetImport,
    OrderArea,
    OrderBrand,
    OrderDevice,
    OrdertParts,
    dialogImgLarge,
    CustomerAddDialog,
    OrderNotice,
    SelectFaultDialog
  }
})

export default class extends Vue {
  private servicerChange(orderType:any) {
    this.isShowTag = addOrderServerIsHave(Type.tag, orderType, '');
    this.isShowFaultType = addOrderServerIsHave(Type.fault, orderType, '');
    this.isShowFaultPhenomenon = addOrderServerIsHave(Type.FAULT_PHENOMENON, orderType, '');
    this.isShowProduct = addOrderServerIsHave(Type.product, orderType, '');
    this.isShowSerDept = addOrderServerIsHave(Type.dept, orderType, '');
    this.isShowAppointment = addOrderServerIsHave(Type.time, orderType, '');
    this.isShowPic = addOrderServerIsHave(Type.photo, orderType, '');
    this.isShowSound = addOrderServerIsHave(Type.sound, orderType, '');
    this.isShowAddressPca = addOrderServerIsHave(Type.pca, orderType, '');
    this.isShowVideo = addOrderServerIsHave(Type.video, orderType, '');
    this.isShowPrice = addOrderServerIsHave(Type.price, orderType, '');
    this.isShowDevice = addOrderServerIsHave(Type.device, orderType, '');
    this.isShowDeviceSN = addOrderServerIsHave(Type.SN, orderType, '');
    this.isShowParts = addOrderServerIsHave(Type.parts, orderType, '');
    this.isShowRemark = addOrderServerIsHave(Type.remark, orderType, '');
    this.isShowAddress = addOrderServerIsHave(Type.address, orderType, '');

    this.isShowContentUser = addOrderServerIsHave(Type.contentUser, orderType, '');
    this.isShowContentUserMobile = addOrderServerIsHave(Type.contentUserMobile, orderType, '');
    this.isShowContentUserPhone = addOrderServerIsHave(Type.contentUserPhone, orderType, '');
    this.isShowDescription = addOrderServerIsHave(Type.Description, orderType, '');

    this.isShowDiyOne = addOrderServerIsHave(Type.DiyOne, orderType, '');
    this.isShowDiyTwo = addOrderServerIsHave(Type.DiyTwo, orderType, '');

    this.isShowWordFile = addOrderServerIsHave(Type.WordFile, orderType, '');

    this.isMustTag = addOrderServerIsMust(Type.tag, orderType, '');
    this.isMustFaultType = addOrderServerIsMust(Type.fault, orderType, '');
    this.isMustFaultPhenomenon = addOrderServerIsMust(Type.FAULT_PHENOMENON, orderType, '');
    this.isMustProduct = addOrderServerIsMust(Type.product, orderType, '');
    this.isMustSerDept = addOrderServerIsMust(Type.dept, orderType, '');
    this.isMustAppointment = addOrderServerIsMust(Type.time, orderType, '');
    this.isMustPic = addOrderServerIsMust(Type.photo, orderType, '');
    this.isMustSound = addOrderServerIsMust(Type.sound, orderType, '');
    this.isMustAddressPca = addOrderServerIsMust(Type.pca, orderType, '');
    this.isMustVideo = addOrderServerIsMust(Type.video, orderType, '');
    this.isMustPrice = addOrderServerIsMust(Type.price, orderType, '');
    this.isMustDevice = addOrderServerIsMust(Type.device, orderType, '');
    this.isMustDeviceSN = addOrderServerIsMust(Type.SN, orderType, '');
    this.isMustParts = addOrderServerIsMust(Type.parts, orderType, '');
    this.isMustRemark = addOrderServerIsMust(Type.remark, orderType, '');

    this.isMustContentUser = addOrderServerIsMust(Type.contentUser, orderType, '');
    this.isMustContentUserMobile = addOrderServerIsMust(Type.contentUserMobile, orderType, '');
    this.isMustContentUserPhone = addOrderServerIsMust(Type.contentUserPhone, orderType, '');
    this.isMustDescription = addOrderServerIsMust(Type.Description, orderType, '');
    this.isMustAddress = addOrderServerIsMust(Type.address, orderType, '');

    this.isMustDiyOne = addOrderServerIsMust(Type.DiyOne, orderType, '');
    this.isMustDiyTwo = addOrderServerIsMust(Type.DiyTwo, orderType, '');

    this.isMustWordFile = addOrderServerIsMust(Type.WordFile, orderType, '');
  }
  // 维修。安装 其他 模块判断
  private isHaveFixModel=((UserModule.getCompany as any) && (UserModule.getCompany as any).fix_module);
  private isHaveInstallModel=((UserModule.getCompany as any) && (UserModule.getCompany as any).install_module)

  private isShowTag=false;
  private isMustTag=false;

  private isShowFaultType=false;
  private isMustFaultType=false;

  private isShowFaultPhenomenon=false;
  private isMustFaultPhenomenon=false;

  private isShowProduct=false;
  private isMustProduct=false;

  private isShowDevice=false;
  private isMustDevice=false;

  private isShowDeviceSN=false;
  private isMustDeviceSN=false;

  private isShowParts=false;
  private isMustParts=false;

  private isShowSerDept=false;
  private isMustSerDept=false;

  private isShowAppointment=false;
  private isMustAppointment=false;

  private isShowPic=false;
  private isMustPic=false;

  private isShowRemark=false;
  private isMustRemark=false;

  private isShowSound=false;
  private isMustSound=false;

  private isShowVideo=false;
  private isMustVideo=false;

  private isShowAddressPca=false;
  private isMustAddressPca=false;

  private isShowPrice=false;
  private isMustPrice=false;

  private isShowDiyOne=false;
  private isMustDiyOne=false;

  private isShowDiyTwo=false;
  private isMustDiyTwo=false;

  private isShowWordFile=false;
  private isMustWordFile=false;

  // 默认显示
  private isShowAddress=true;
  private isShowContentUser=true;
  private isShowContentUserMobile=true;
  private isShowContentUserPhone=true;
  private isShowDescription=true;

  private isMustAddress=false;
  private isMustContentUser=false;
  private isMustContentUserMobile=false;
  private isMustContentUserPhone=false;
  private isMustDescription=false;

  private dynamicCost:any = [];
  private costList:any = [];

  private serverCompanyId:string='';
  private serverCompanyName:string='';

  private isShowIsSelf=false;

  private formAdd:any={
    name: '',
    mobile: '',
    phone: '',
    customer: {}
  }
  private orderType:any='2'

  private customerOnceTime=''

  // 骑牛
  private action = 'https://up-z1.qiniup.com';
  private qiuniuToken:any={}
  private qiuniuform={}
  private qiniuPicList:any=[]
  private qiniuSoundList:any=[]
  private qiniuVideoList:any=[]
  private qiniuWordFileList: any = []

  private placeholderProduct='品牌类型'

  created() {
    if (UserModule.company && UserModule.company.brand_name_alias) {
      this.placeholderProduct = UserModule.company.brand_name_alias;
    } else {
      this.placeholderProduct = '品牌类型';
    }
    this.isShowIsSelf = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.IsSelfTask);
    this.serverCompanyId = UserModule.getCompanyId;
    this.serverCompanyName = UserModule.getCompanyName;
    this.initOrder(0);
    this.servicerChange(this.orderType);
  }

  private serDrptOptions:any = []

  // 初始化
  private initOrder(type:number) {
    // type 1 =报修后再次初始化 0= 进入页面初始化
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    getOrderServiceInit(params).then(res => {
      if (res.data) {
        this.serDrptOptions = res.data.dept_list;
        this.qiuniuToken = res.data.uptoken;
        if (res.data.repair_prompt && res.data.repair_prompt.title) {
          this.noticeVisible = true;
          this.noticeData = res.data.repair_prompt;
          this.noticeData.serNum = 1;
        }
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private handlePictureCardPreview() {

  }

  // 导入订单
  private isImportorder=false
  private setImportVisible=false
  private setImportTitle='导入订单'
  private downloadExcelHandle() {
    window.location.href = process.env.BASE_URL + 'static/frontUserNew/template/import_order.xlsx';
  }
  private customerImportorder='';
  private importOrderHandle() {
    this.isImportorder = true;
    this.customerDialogVisible = true;
  }
  private closeImport(val: any) {
    this.isImportorder = false;
    this.customerDialogVisible = false;
    this.setImportVisible = val;
  }

  // 订单类型
  // private orderTypeChage(val:any) {
  //   if (parseInt(val) === 3) {
  //     this.$router.push({
  //       path: '/OrderInstall/OrderInstallAdd'
  //     });
  //     return;
  //   }
  //   this.orderType = val;
  //   this.servicerChange(this.orderType);
  // }
  // 选择部门
  private departmentVisible = false
  private title = '选择部门'

  private selectDeptServicerHandle() {
    this.departmentVisible = true;
  }
  private selectDept(val:any) {
    this.formAdd.servicerDept = val;
  }
  private closeDeptHandle(value: boolean) {
    this.departmentVisible = value;
  }

  // 订单标签
  private selectTagArray:any = []
  private tagVisible = false
  private selectTag() {
    if (this.selectTagArray && this.selectTagArray.length >= 3) {
      this.showErrorMsg('最多只能选择3个标签');
      return;
    }
    if (this.serverCompanyId) {
      this.tagVisible = true;
    }
  }

  private closeTagHandle(value:boolean) {
    this.tagVisible = value;
  }
  private delTagHandle(val: any) {
    this.selectTagArray.splice(this.selectTagArray.indexOf(val), 1);
  }
  private confirmTagHandle(value:any) {
    this.tagVisible = false;
    let filter = this.selectTagArray.filter((tag:any) => {
      return tag.tags_id === value.tags_id;
    });
    if (filter && filter.length > 0) {
      return;
    }
    this.selectTagArray.push(value);
    let descriptionPlaceholdera = '';
    if (this.selectTagArray && this.selectTagArray.length > 0) {
      for (var i = 0; i < this.selectTagArray.length; i++) {
        if (this.selectTagArray[i].trouble_describle_prompt) {
          descriptionPlaceholdera += (this.selectTagArray[i].trouble_describle_prompt + ';');
        }
      }
    }
    // if (descriptionPlaceholdera && descriptionPlaceholdera.length > 0) {
    //   this.placeHolderDescription = descriptionPlaceholdera.slice(0, descriptionPlaceholdera.length - 1);
    // }
  }
  // 故障类型 Phenomenon
  private faultTypeArray:any=[];
  private faultVisible=false;
  private isPhenomenon=false;
  private delFaultHandle(val: any) {
    this.faultTypeArray.splice(this.faultTypeArray.indexOf(val), 1);
  }

  private selectFaultHandle(val:any) {
    this.companyId = UserModule.getCompanyId;
    this.faultVisible = true;
    this.isPhenomenon = val;
  }
  private comfirmSelectFault(val:any) {
    this.faultVisible = false;

    if (this.isPhenomenon) {
      this.formAdd.faultPhenomenonParent = val.faultTypeParent;
      this.formAdd.faultPhenomenon = val.faultType;
      this.formAdd.faultPhenomenonStr = this.formAdd.faultPhenomenonParent.name;
      if (this.formAdd.faultPhenomenon && this.formAdd.faultPhenomenon.id) {
        this.formAdd.faultPhenomenonStr = this.formAdd.faultPhenomenonStr + '/' + this.formAdd.faultPhenomenon.name;
      }
    } else {
      let faultTypeStr = val.faultTypeParent.name;
      if (val.faultType && val.faultType.id) {
        faultTypeStr = faultTypeStr + '/' + val.faultType.name;
      }
      let arr = this.faultTypeArray.filter((item:any) => {
        return item.faultTypeStr === faultTypeStr
      })
      if (arr && arr.length > 0) {
        return
      }
      let fault = {
        faultTypeStr: faultTypeStr,
        faultTypeParent: val.faultTypeParent,
        faultType: val.faultType
      }
      this.faultTypeArray.push(fault);
    }
  }
  private closeSelectFaultDialog(val:any) {
    this.faultVisible = val;
  }

  // 任务描述
  private dynamicDescription:any[] = []
  private descriptionAddHandle() {
    if (this.dynamicDescription && this.dynamicDescription.length > 3) {
      this.$alert('最多添加5条任务描述', '提示', {
        confirmButtonText: '确定',
        callback: action => {

        }
      });
    } else {
      this.dynamicDescription.push({
        value: ''
      });
    }
  }
  private descriptionDeleteHandle(value: any) {
    // 删除新增的任务描述
    let index = this.dynamicDescription.indexOf(value);
    if (index !== -1) {
      this.dynamicDescription.splice(index, 1);
    }
  }
  // 选择客户
  private customerDialogVisible=false;
  private selectCustomerVisible() {
    this.isImportorder = false;
    this.customerDialogVisible = true;
  }
  private closeCustomerDialog(val:any) {
    this.customerDialogVisible = val;
  }
  private SelectCus(cus:any) {
    this.formAdd.customer = cus;
    this.provinceName = cus.province_name;
    this.province = cus.province;
    this.cityName = cus.city_name;
    this.city = cus.city;
    this.districtName = cus.district_name;
    this.district = cus.district;
    this.formAdd.area = this.provinceName !== this.cityName
      ? this.provinceName + '  ' + this.cityName + '  ' + this.districtName
      : this.provinceName + '  ' + this.districtName;
    this.$set(this.formAdd, 'addressDetail', cus.address);
    this.formAdd.name = cus.manager;
    this.formAdd.mobile = cus.mobile;
    this.formAdd.phone = cus.phone_num;
    if (this.isImportorder) {
      this.customerImportorder = cus;
      this.setImportVisible = true;
    }
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.address = cus.address;
    pamars.customer_user_id = cus.customer_user_id;
    pamars.customer_company_id = cus.customer_company_id;
    pamars.customer_type = cus.customer_type;
    getCustomerAddressInfo(pamars).then(res => {
      if (res.data) {
        this.customerOnceTime = res.data.exist_repair_time;
      } else {
        this.customerOnceTime = '';
      }
    }).catch(err => {
      let msg = err.msg;
      this.customerOnceTime = '';
    });
  }

  // 添加客户
  private dialogAddCustomerVisible=false
  private closeAddCustomerDialog(val: any) {
    this.dialogAddCustomerVisible = val;
  }
  private addCustomerHandle(data: any) {
    let params = data.p;
    let res = data.res;
    this.adcode = params.adcode;
    this.provinceName = params.provinceName;
    this.province = params.province;
    this.cityName = params.cityName;
    this.city = params.city;
    this.districtName = params.districtName;
    this.district = params.district;
    if (this.provinceName) {
      this.formAdd.area = this.provinceName !== this.cityName
        ? this.provinceName + '  ' + this.cityName + '  ' + this.districtName
        : this.provinceName + '  ' + this.districtName;
    }
    this.$set(this.formAdd, 'address', params.address);
    this.formAdd.mobile = params.mobile;
    this.formAdd.phone = params.phone;
    this.formAdd.customer = {};
    switch (parseInt(params.type)) {
      case 1:
        // 公司
        this.formAdd.customer.customer_company_id = res.data.id;
        this.formAdd.customer.name = params.name;
        this.formAdd.customer.customer_type = params.type;
        this.formAdd.name = params.manager;
        break;
      case 2:
        // 个人
        this.formAdd.name = params.name;
        this.formAdd.customer.customer_user_id = res.data.uid;
        this.formAdd.customer.name = params.name;
        this.formAdd.customer.customer_type = params.type;
        break;
    }
    this.dialogAddCustomerVisible = false;
  }

  // 选择省市区
  private areaVisible = false
  private provinceName=''
  private province=''
  private cityName=''
  private city=''
  private districtName=''
  private district=''
  private adcode=''
  private selectAreaHandle() {
    this.areaVisible = true;
  }
  private closeAreaHandle(value:boolean) {
    this.areaVisible = value;
  }
  private saveAreaHandle(value:any) {
    this.adcode = '';
    this.provinceName = value.province_name;
    this.province = value.province;
    this.cityName = value.city_name;
    this.city = value.city;
    this.districtName = value.district_name;
    this.district = value.district;
    this.formAdd.area = value.province_name !== value.city_name
      ? value.province_name + '  ' + value.city_name + '  ' + value.district_name
      : value.province_name + '  ' + value.district_name;
    this.areaVisible = false;
  }
  // 费用
  private getPriceList() {
    let parameters:any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = this.serverCompanyId;
    getPriceList(parameters).then(res => {
      if (res.data) {
        this.costList = res.data.list;
      } else {
        this.costList = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private priceChange(price:any) {
    this.$set(this.formAdd, 'costValue', price.price_num);
  }
  private priceNewChange(index:number, price:any) {
    this.$set(this.dynamicCost[index], 'value', price.price_num);
  }
  // 附件

  // 品牌
  private brandVisible = false;
  private productBean:any = ''
  private selectBrandHandle() {
    this.brandVisible = true;
  }
  private confirmBrandHandle(val:any) {
    this.productBean = val;
    this.formAdd.brand = this.productBean.brand_name;
    if (this.productBean.product_name) {
      this.formAdd.brand = this.formAdd.brand + '/' + this.productBean.product_name;
    }
    if (this.productBean.model_name) {
      this.formAdd.brand = this.formAdd.brand + '/' + this.productBean.model_name;
    }
  }
  private closeBrandHandle(value: boolean) {
    this.brandVisible = value;
  }

  // 设备
  private deviceVisible = false
  private selectDevice:any = []
  private selectDeviceHandle() {
    this.deviceVisible = true;
  }

  private confirmDeviceHandle(value: any) {
    this.selectDevice = value;
  }
  private cleanDevice(val:any, index:any) {
    this.selectDevice.splice(index, 1);
  }
  private closeDeviceHandle(value: boolean) {
    this.deviceVisible = value;
  }

  // 备件
  private partsVisible = false;
  private companyId = '';
  private selectParts:any=[];
  private selectPartsHandle() {
    this.partsVisible = true;
    this.companyId = UserModule.getCompanyId;
  }
  private confirmPartsHandle(val:any) {
    this.selectParts.push(val);
  }
  private cleanPart(val:any, index:any) {
    this.selectParts.splice(index, 1);
  }
  private closeParts(val:boolean) {
    this.partsVisible = val;
  }

  // 预约时间
  private appointmentDayTimestamp:any=''
  private pickerChange(val:any) {
    let minite = val.slice(-2);
    let hour = val.slice(-5, -3);
    val = val.slice(0, -5);
    let minite2 = '00';
    let i = Math.ceil(parseInt(minite) / 5);
    if (i * 5 < 10) {
      minite2 = '0' + i * 5;
    } else {
      minite2 = '' + i * 5;
    }
    val = val + hour + ':' + minite2;
    let ieval = val.replace(/-/g, '/');
    let data = new Date(ieval);
    this.appointmentDayTimestamp = data.getTime() / 1000;
    this.formAdd.appointment = val;
  }
  // 指派部门
  private serDealDeptment=UserModule.getUserDeptList;
  // qiniu
  private uploadSuccess(res: any) {
    this.qiniuPicList.push(res.key);
  }
  private beforeUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then(res => {
      let k = makeKey(this.qiuniuToken.prekey);
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain
      };
    });
  }
  private handleUploadSuccessSound(res: any) {
    // http://test-img.baoxiuguanjia.com//t/2020/11/06/1604654608290.mp3
    // getAvinfo('http://test-img.baoxiuguanjia.com//t/2020/11/06/1604654608290.mp3');
    this.qiniuSoundList.push(
      { url: res.key,
        full_path: this.qiuniuToken.default_url + res.key,
        seconds: 1,
        isPlaying: false
      }
    );
  }
  private beforeUploadUploadSound(file:any) {
    const isJPG = file.type === 'audio/mpeg' || 'audio/mp3';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是 mp3 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传音频大小不能超过 5MB!');
    }
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then(res => {
      let k = makeKey(this.qiuniuToken.prekey);
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain
      };
    });
  }
  private voiceHandle(val: any, index: number) {
    let _this = this;
    let amr = new BenzAMRRecorder();

    for (let i = 0; i < val.length; i++) {
      if (i === index) {
        val[i].isPlaying = true;
      }
      val[i].isPlaying = false;
    }

    amr.initWithUrl(val[index].full_path).then(function() {
      val[index].isPlaying = true;
      amr.play();
      _this.$set(val, index, val[index]);
    });

    amr.onEnded(function() {
      amr.stop();
      val[index].isPlaying = false;
      _this.$set(val, index, val[index]);
    });
  }
  private handleUploadSuccessVideo(res: any) {
    getAvinfo(this.qiuniuToken.default_url + res.key).then(avinfo => {
      if (avinfo) {
        this.qiniuVideoList.push(
          { url: res.key,
            full_path: this.qiuniuToken.default_url + res.key,
            seconds: Math.round((avinfo as any).duration),
            isPlaying: false
          }
        );
      }
    });
  }
  private beforeUploadUploadVideo(file:any) {
    const isJPG = file.type === 'video/mp4';
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isJPG) {
      return this.$message.error('上传文件只能是 mp4 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传视频大小不能超过 20MB!');
    }
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then(res => {
      let k = makeKey(this.qiuniuToken.prekey) + '.mp4';
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain
      };
    });
  }

  private uploadSuccessDocument(res:any, file:any, fileList:any) {
    this.qiniuWordFileList = fileList;
  }
  private beforeUploadDocument(file:any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      this.qiuniuform = {
        key: makeKey(this.qiuniuToken.prekey),
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain
      };
    });
  }
  private onExceed() {
    this.$message.error('最多上传4个文档');
  }
  private onRemove(file:any, fileList:any) {
    this.qiniuWordFileList = fileList;
  }

  private imgLargeHandle(val: [], index: number, type: number) {
    let arr = [];
    if (type === 2) {
      let h: any = {};
      h.media_type = type;
      h.video_url = val;
      arr.push(h);
    } else {
      for (let i = 0; i < val.length; i++) {
        arr.push(this.qiuniuToken.default_url + val[i]);
      }
    }
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private deleteImgHandle(val:any, num:number) {
    // 1 pic 2 sound 3 video
    switch (num) {
      case 1:
        for (var i = 0; i < this.qiniuPicList.length; i++) {
          if (this.qiniuPicList[i] === val) {
            this.qiniuPicList.splice(i, 1);
          }
        }
        break;
      case 2:
        for (var m = 0; m < this.qiniuSoundList.length; m++) {
          if (this.qiniuSoundList[m].url === val.url) {
            this.qiniuSoundList.splice(m, 1);
          }
        }
        break;
      case 3:
        for (var n = 0; n < this.qiniuVideoList.length; n++) {
          if (this.qiniuVideoList[n].full_path === val.full_path) {
            this.qiniuVideoList.splice(n, 1);
          }
        }
        break;
    }
  }
  private createOrder() {
    var parameters:any = {};
    // 1是自己报，2是替客户报
    parameters['order_create_type'] = '2';
    if (!this.orderType) {
      this.showErrorMsg('请选择订单类型');
    }
    parameters['order_type'] = this.orderType;

    parameters['user_id'] = UserModule.getUserId;
    parameters['user_name'] = UserModule.getUserName;

    parameters['company_id'] = UserModule.getCompanyId;
    parameters['servicer_company_id'] = UserModule.getCompanyId;
    parameters['servicer_company_name'] = UserModule.getCompanyName;

    if (!(this.formAdd.servicerDept && this.formAdd.servicerDept.dept_id) && this.isMustSerDept) {
      this.showErrorMsg('请选择服务部门');
      return;
    }
    if (this.formAdd.servicerDept) {
      if(this.isShowSerDept){
        parameters['servicer_dept_id'] = this.formAdd.servicerDept.dept_id;
        parameters['servicer_dept_name'] = this.formAdd.servicerDept.name;
      }
    }
    if (!(this.selectTagArray && this.selectTagArray.length > 0) && this.isMustTag) {
      this.showErrorMsg('请添加订单标签');
      return;
    }
    if (this.selectTagArray && this.selectTagArray.length > 0) {
      let array:any = [];
      for (var i = 0; i < this.selectTagArray.length; i++) {
        let item = this.selectTagArray[i];
        let dic = {
          'tags_name': item.tags_name,
          'tags_id': item.tags_id
        };
        array.push(dic);
      }
      parameters['tags'] = JSON.stringify(array);
    }
    // 故障类型

    if (!(this.faultTypeArray && this.faultTypeArray.length > 0) && this.isMustFaultType) {
      this.showErrorMsg('请添加故障类型啊');
      return;
    }
    if (this.faultTypeArray && this.faultTypeArray.length > 0) {
      let faultArr = []
      for (let i = 0; i < this.faultTypeArray.length; i++) {
        let item = this.faultTypeArray[i];
        let faultTypeBean:any = {};
        if (item.faultTypeParent && item.faultTypeParent.id) {
          faultTypeBean.p_fault_type_name = item.faultTypeParent.name;
          faultTypeBean.p_fault_type_id = item.faultTypeParent.id;
        }
        if (item.faultType && item.faultType.id) {
          faultTypeBean.fault_type_name = item.faultType.name;
          faultTypeBean.fault_type_id = item.faultType.id;
          faultTypeBean.level = item.faultType.level;
        }
        faultArr.push(faultTypeBean);
        var strFault = JSON.stringify(faultArr);
        parameters['fault_type'] = strFault;
      }
    }

    // 故障现象
    let faultPhenomenonBean:any = {};
    if (this.formAdd.faultPhenomenonParent && this.formAdd.faultPhenomenonParent.id) {
      faultPhenomenonBean.p_fault_type_name = this.formAdd.faultPhenomenonParent.name;
      faultPhenomenonBean.p_fault_type_id = this.formAdd.faultPhenomenonParent.id;
    }
    if (this.formAdd.faultPhenomenon && this.formAdd.faultPhenomenon.id) {
      faultPhenomenonBean.fault_type_name = this.formAdd.faultPhenomenon.name;
      faultPhenomenonBean.fault_type_id = this.formAdd.faultPhenomenon.id;
    }
    if (!(faultPhenomenonBean && faultPhenomenonBean.p_fault_type_id) && this.isMustFaultPhenomenon) {
      this.showErrorMsg('请添加故障现象');
      return;
    }
    if (faultPhenomenonBean && faultPhenomenonBean.p_fault_type_id) {
      let arrayfault = [];
      arrayfault[0] = faultPhenomenonBean;
      var strFaultPhenomenon = JSON.stringify(arrayfault);
      parameters['fault_phenomenon'] = strFaultPhenomenon;
    }
    let troubleDes = '';
    let num = 0;
    if (this.formAdd.description) {
      num = num + 1;
      troubleDes = num + '、' + this.formAdd.description + ';';
    }
    this.dynamicDescription.forEach(des => {
      if (des.value) {
        num = num + 1;
        troubleDes = troubleDes + num + '、' + des.value + ';';
      }
    });
    if (!(troubleDes && troubleDes.length > 0) && this.isMustDescription) {
      this.showErrorMsg('请输入故障描述');
      return;
    }
    if (this.isShowDescription) {
      parameters['trouble_describle'] = troubleDes;
    }

    // 客户
    if (!this.formAdd.customer || !this.formAdd.customer.customer_type) {
      this.showErrorMsg('请选择客户');
      return;
    }

    switch (parseInt(this.formAdd.customer.customer_type)) {
      case 1:
        parameters['customer_company_id'] = this.formAdd.customer.customer_company_id;
        parameters['customer_company_name'] = this.formAdd.customer.name;
        break;
      case 2:
        parameters['customer_user_id'] = this.formAdd.customer.customer_user_id;
        parameters['customer_user_name'] = this.formAdd.customer.name;
        break;
    }

    if (!(this.qiniuPicList && this.qiniuPicList.length > 0) && this.isMustPic) {
      this.showErrorMsg('请添加图片');
      return;
    }
    if (this.qiniuPicList && this.qiniuPicList.length > 0) {
      var imageString = '';
      for (var m = 0; m < this.qiniuPicList.length; m++) {
        imageString += this.qiniuPicList[m];
        if (m !== this.qiniuPicList.length - 1) {
          imageString += ',';
        }
      }
      parameters['trouble_image'] = imageString;
    }
    if (!(this.qiniuSoundList && this.qiniuSoundList.length > 0) && this.isMustSound) {
      this.showErrorMsg('请添加语音');
      return;
    }
    if (this.qiniuSoundList && this.qiniuSoundList.length > 0) {
      let arraySound:any = [];
      for (var itemSound of this.qiniuSoundList) {
        let sound = {
          'original_name': itemSound.full_path,
          'seconds': itemSound.seconds,
          'save_path': itemSound.url
        };
        arraySound.push(sound);
      }
      var strSound = JSON.stringify(arraySound);
      parameters['voice'] = strSound;
    }
    // video
    if (!(this.qiniuVideoList && this.qiniuVideoList.length > 0) && this.isMustVideo) {
      this.showErrorMsg('请添加视频');
      return;
    }
    if (this.qiniuVideoList && this.qiniuVideoList.length > 0) {
      let arrayVoice:any = [];
      for (var itemVoice of this.qiniuVideoList) {
        let Voice = {
          'original_name': itemVoice.full_path,
          'seconds': itemVoice.seconds,
          'save_path': itemVoice.url
        };
        arrayVoice.push(Voice);
      }
      var strVoice = JSON.stringify(arrayVoice);
      parameters['video'] = strVoice;
    }
    // 文档
    if (!(this.qiniuWordFileList && this.qiniuWordFileList.length > 0) && this.isMustWordFile) {
      this.showErrorMsg('请添加文档');
      return;
    }
    if (this.qiniuWordFileList && this.qiniuWordFileList.length > 0) {
      let arrayWD:any = [];
      for (let itemw of this.qiniuWordFileList) {
        let wd = {
          'original_name': itemw.name,
          'save_path': itemw.response.key
        };
        arrayWD.push(wd);
      }
      let strWD = JSON.stringify(arrayWD);
      parameters['document'] = strWD;
    }
    if (!this.productBean && this.isMustProduct) {
      this.showErrorMsg('请添加' + this.placeholderProduct);
      return;
    }
    if (!this.provinceName && this.isMustAddressPca) {
      this.showErrorMsg('请选择省市区');
      return;
    }
    if (!this.formAdd.addressDetail && this.isMustAddress) {
      this.showErrorMsg('请输入地址');
      return;
    }
    if (this.isShowAddressPca) {
      parameters['province_name'] = this.provinceName;
      parameters['city_name'] = this.cityName;
      parameters['district_name'] = this.districtName;
      parameters['province'] = this.province;
      parameters['city'] = this.city;
      parameters['district'] = this.district;
    }
    if (this.isShowAddress) {
      parameters['address'] = this.formAdd.addressDetail;
    }

    if (!this.formAdd.appointment && this.isMustAppointment && !this.appointmentDayTimestamp) {
      this.showErrorMsg('请选择预约时间');
      return;
    }
    if (this.appointmentDayTimestamp) {
      parameters['servicer_appointment_time'] = this.appointmentDayTimestamp;
    }

    // 费用

    let costList:any = [];
    if (this.formAdd.costType && this.formAdd.costType.id) {
      let cost:any = {};
      cost.price_id = this.formAdd.costType.id;
      cost.price_name = this.formAdd.costType.price_name;
      cost.price_num = this.formAdd.costValue;
      costList.push(cost);
    }
    if (this.dynamicCost && this.dynamicCost.length > 0) {
      for (var cost of this.dynamicCost) {
        if (cost.type && cost.type.id) {
          let costs:any = {};
          costs.price_id = cost.type.id;
          costs.price_name = cost.type.price_name;
          costs.price_num = cost.value;
          costList.push(costs);
        }
      }
    }
    if (!(costList && costList.length > 0) && this.isMustPrice) {
      this.showErrorMsg('请添加费用');
      return;
    }
    if (costList && costList.length > 0) {
      var strCostList = JSON.stringify(costList);
      parameters['price'] = strCostList;
    }
    if ((!this.productBean || !this.productBean.brand_id) && this.isMustProduct) {
      this.showErrorMsg('请添加' + this.placeholderProduct);
      return;
    }
    if (this.productBean && this.productBean.brand_id) {
      let arrayproduct = [];
      arrayproduct[0] = this.productBean;
      var str = JSON.stringify(arrayproduct);
      parameters['product'] = str;
    }
    if (!this.formAdd.deviceSN && this.isMustDeviceSN) {
      this.showErrorMsg('请添加设备编号');
      return;
    }
    parameters['device_sn'] = this.formAdd.deviceSN;
    if (!(this.selectDevice && this.selectDevice.length > 0) && this.isMustDevice) {
      this.showErrorMsg('请添加设备');
      return;
    }
    if (this.selectDevice && this.selectDevice.length > 0) {
      var arrayDevice:any = [];
      this.selectDevice.forEach((device:any) => {
        var dic = {
          'device_id': device.id
        };
        arrayDevice.push(dic);
      });
      var strDevice = JSON.stringify(arrayDevice);
      parameters['device'] = strDevice;
    }

    if (!(this.selectParts && this.selectParts.length > 0) && this.isMustParts) {
      this.showErrorMsg('请添加备件');
      return;
    }
    if (this.selectParts && this.selectParts.length > 0) {
      var strParts = JSON.stringify(this.selectParts);
      parameters['parts'] = strParts;
    }
    if (!this.formAdd.diyOne && this.isMustDiyOne) {
      this.showErrorMsg('请输入自定义1');
      return;
    }
    parameters['diy_one_content'] = this.formAdd.diyOne;
    if (!this.formAdd.diyTwo && this.isMustDiyTwo) {
      this.showErrorMsg('请输入自定义2');
      return;
    }
    parameters['diy_two_content'] = this.formAdd.diyTwo;
    // 加急
    parameters['expedited'] = this.formAdd.isUrgent ? '1' : '0';

    if (!this.formAdd.remark && this.isMustRemark) {
      this.showErrorMsg('请添加备注');
      return;
    }
    if (this.formAdd.remark) {
      let remarkList:any = [];
      remarkList.push(this.formAdd.remark);
      let remark = JSON.stringify(remarkList);
      parameters['remark'] = remark;
    }
    if (!this.formAdd.name && this.isMustContentUser) {
      this.showErrorMsg('请输入联系人姓名');
      return;
    }
    if (this.formAdd.name) {
      if (this.formAdd.name.length < 2 && this.formAdd.name.length > 10) {
        this.showErrorMsg('请输入2-10位联系人姓名');
        return;
      }
    }
    if (this.isShowContentUser) {
      parameters['name'] = this.formAdd.name;
    }

    if (!(this.formAdd.mobile && this.formAdd.mobile.length > 0) && this.isMustContentUserMobile) {
      this.showErrorMsg('请输入手机号码');
      return;
    }
    if (this.formAdd.mobile && this.formAdd.mobile.length > 0) {
      if (!(this.formAdd.mobile.charAt(0) === '1' && this.formAdd.mobile.length === 11)) {
        this.showErrorMsg('请输入正确的手机号码');
        return;
      }
      if (this.isShowContentUserMobile) {
        parameters['mobile'] = this.formAdd.mobile;
      }
    }
    if (!(this.formAdd.phone && this.formAdd.phone.length > 0) && this.isMustContentUserPhone) {
      this.showErrorMsg('请输入联系电话');
      return;
    }
    if (this.formAdd.phone && this.formAdd.phone.length > 0) {
      if (!(this.formAdd.phone.length >= 3 && this.formAdd.phone.length <= 18)) {
        this.showErrorMsg('请输入3-18位联系电话,支持输入"-"、" _"');
        return;
      }
      if (this.isShowContentUserPhone) {
        parameters['phone_num'] = this.formAdd.phone;
      }
    }
    if (!this.isMustContentUserPhone && !this.isMustContentUserMobile && this.isShowContentUserMobile && this.isShowContentUserPhone &&
    !(this.formAdd.mobile && this.formAdd.mobile.length > 0) && !(this.formAdd.phone && this.formAdd.phone.length > 0)) {
      this.showErrorMsg('请输入手机号码 或 3-18位联系电话,支持输入"-"、" _"');
      return;
    }
    if (this.formAdd.isSelf && (this.serDealDeptment && this.serDealDeptment.length > 0) &&
    (!this.formAdd.sendDept || !this.formAdd.sendDept.dept_id)) {
      this.showErrorMsg('请选择自己的部门');
      return;
    }
    parameters['allot_dept_state'] = this.formAdd.isSelf ? 1 : 0;
    if (this.formAdd.sendDept) {
      parameters['allot_dept_id'] = this.formAdd.sendDept.dept_id;
      parameters['allot_dept_name'] = this.formAdd.sendDept.name;
    }

    this.requestToCreateOrder(parameters);
  }
  private isCommitBtn=true
  private requestToCreateOrder(parameters:any) {
    var _this = this;
    if (!_this.isCommitBtn) {
      return;
    }
    _this.isCommitBtn = false;
    createOrderService(parameters).then(res => {
      _this.isCommitBtn = true;
      let content = '是否立即处理订单';
      if (this.formAdd.isSelf) {
        content = '并成功给你分派任务，是否立即处理？';
      }
      let show = false
      if ((checkPermissionUseAndCompany(UserModule.getCompanyId, Type.ORDER_DEAL) && !checkPermissionUseAndCompany(UserModule.getCompanyId, Type.ORDER_ROB_DEAL)) && !_this.formAdd.isSelf) {
        show = true;
      }
      if (checkPermissionUseAndCompany(UserModule.getCompanyId, Type.TASK_DEAL) && _this.formAdd.isSelf) {
        show = true;
      }
      this.$alert(show ? content : '', '添加成功', {
        cancelButtonText: show ? '取消' : '我知道了',
        confirmButtonText: '立即处理',
        showClose: false,
        showCancelButton: true,
        showConfirmButton: show,
        type: 'success',
        center: true,
        callback: action => {
          if (action === 'confirm') {
            if (show) {
              if (!_this.formAdd.isSelf) {
                _this.$router.push({
                  path: '/OrderServicer/todealing',
                  query: { order_service_id: res.data.order_service_id, company_id: UserModule.getCompanyId }
                });
              } else {
                _this.$router.push({
                  path: '/Task/todealing',
                  query: { taskId: res.data.order_task_id, companyId: UserModule.getCompanyId, orderType: '2', enterType: '1' }
                });
              }
            } else {
              _this.restReportData();
            }
          } else {
            _this.restReportData();
          }
        }
      }).then(() => {
        _this.restReportData();
      });
    }).catch(error => {
      _this.isCommitBtn = true;
      if (error.code === 405119) {
        // this.setData({
        //   pcaString: '',
        //   pcaSeltString: ''
        // });
      }
      _this.showErrorMsg(error.msg);
    });
  }
  private restReportData() {
    this.initOrder(1);

    this.selectTagArray = [];
    this.$set(this.formAdd, 'tag', '');

    this.dynamicDescription = [];
    this.$set(this.formAdd, 'description', '');

    this.qiniuPicList = [];
    this.qiniuSoundList = [];
    this.qiniuVideoList = [];

    this.$set(this.formAdd, 'brand', '');
    this.productBean = '';

    this.$set(this.formAdd, 'device', '');
    this.selectDevice = [];

    this.$set(this.formAdd, 'costType', '');
    this.$set(this.formAdd, 'costValue', '');
    this.dynamicCost = [];

    this.$set(this.formAdd, 'parts', '');
    this.selectParts = [];

    this.$set(this.formAdd, 'appointment', '');
    this.appointmentDayTimestamp = '';

    this.faultTypeArray = [];
    this.$set(this.formAdd, 'faultTypeStr', '');

    this.$set(this.formAdd, 'faultPhenomenonParent', '');
    this.$set(this.formAdd, 'faultPhenomenon', '');
    this.$set(this.formAdd, 'faultPhenomenonStr', '');

    this.$set(this.formAdd, 'customer', {});
    this.$set(this.formAdd, 'sendDept', '');

    this.$set(this.formAdd, 'name', '');
    this.$set(this.formAdd, 'mobile', '');
    this.$set(this.formAdd, 'phone', '');
    this.$set(this.formAdd, 'addressDetail', '');

    this.$set(this.formAdd, 'remark', '');

    this.$set(this.formAdd, 'diyOne', '');
    this.$set(this.formAdd, 'diyTwo', '');

    this.$set(this.formAdd, 'deviceSN', '');

    this.formAdd.isSelf = false;
    this.customerOnceTime = '';
  }

  // 添加费用
  private addCostHandle() {
    this.dynamicCost.push({
      type: '',
      value: ''
    });
  }
  private removeCostHandle(v:any) {
    let index = this.dynamicCost.indexOf(v);
    if (index !== -1) {
      this.dynamicCost.splice(index, 1);
    }
  }

  // 报修提示
  private noticeVisible = false
  private noticeData:any={}
  private closeNoticeHandle(val: boolean, isCleanSer:boolean) {
    this.noticeVisible = val;
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
